/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type PreviewKind = "A_ROLE" | "BACKGROUND" | "BADGE_DARK" | "BADGE_LIGHT" | "B_ROLE" | "CAROUSEL" | "DETAIL_BACKGROUND" | "EXCERPT" | "HEADSHOT" | "HERO" | "HERO_LOGO" | "LOGO" | "PORTRAIT" | "SQUARE" | "%future added value";
export type SocialMediaPlatformKind = "ANGEL_LIST" | "FACEBOOK" | "INSTAGRAM" | "LINKED_IN" | "MEDIUM" | "OTHER" | "PINTEREST" | "REDDIT" | "SNAPCHAT" | "TUMBLR" | "TWITTER" | "WEIBO" | "WHATS_APP" | "YOU_TUBE" | "%future added value";
export type TopLevelMediaKind = "APPLICATION" | "AUDIO" | "DOCUMENT" | "IMAGE" | "TEXT" | "VIDEO" | "%future added value";
export type personQueryVariables = {
    readonly id: string;
};
export type personQueryResponse = {
    readonly person: {
        readonly hasErrors: boolean | null;
        readonly person: {
            readonly __typename: string;
            readonly description: string | null;
            readonly emailAddresses: ReadonlyArray<string> | null;
            readonly fullName: string | null;
            readonly accountType: {
                readonly kind: string;
                readonly subKind: string | null;
                readonly description: string | null;
            } | null;
            readonly hasPublicPage: boolean | null;
            readonly isEditable: boolean | null;
            readonly isClaimable: boolean | null;
            readonly landingPageUrl: string | null;
            readonly revision: string | null;
            readonly id: string;
            readonly greeting: string | null;
            readonly myList: string | null;
            readonly defaultLocation: {
                readonly id: string | null;
                readonly label: string | null;
            } | null;
            readonly locations: ReadonlyArray<{
                readonly id: string | null;
                readonly label: string | null;
            }> | null;
            readonly previews: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly preview: {
                        readonly link: string | null;
                        readonly kind: PreviewKind | null;
                        readonly mediaAsset: {
                            readonly id: string;
                            readonly files: ReadonlyArray<{
                                readonly id: string;
                                readonly name: string | null;
                                readonly path: string | null;
                            }> | null;
                            readonly topLevelMediaType: {
                                readonly kind: TopLevelMediaKind | null;
                                readonly label: string | null;
                            } | null;
                        } | null;
                    } | null;
                }> | null;
            } | null;
            readonly entities: ReadonlyArray<{
                readonly __typename: string;
                readonly name: string | null;
                readonly id: string;
                readonly revision: string | null;
                readonly hasPublicPage: boolean | null;
                readonly description: string | null;
                readonly tagLine: string | null;
                readonly websiteUrl: string | null;
                readonly landingPageUrl: string | null;
                readonly isEditable: boolean | null;
                readonly previews: {
                    readonly count: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly preview: {
                            readonly link: string | null;
                            readonly mediaAsset: {
                                readonly id: string;
                                readonly files: ReadonlyArray<{
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly path: string | null;
                                }> | null;
                                readonly topLevelMediaType: {
                                    readonly kind: TopLevelMediaKind | null;
                                    readonly label: string | null;
                                } | null;
                            } | null;
                            readonly kind: PreviewKind | null;
                        } | null;
                    }> | null;
                } | null;
            }> | null;
            readonly experience: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly position: {
                        readonly id: string;
                        readonly isCurrent: boolean | null;
                        readonly isDeleted: boolean | null;
                        readonly isFounder: boolean | null;
                        readonly title: string | null;
                        readonly entity: {
                            readonly __typename: string;
                            readonly name: string | null;
                            readonly id: string;
                            readonly description: string | null;
                            readonly websiteUrl: string | null;
                            readonly hasPublicPage: boolean | null;
                            readonly isEditable: boolean | null;
                            readonly landingPageUrl: string | null;
                            readonly previews: {
                                readonly count: number | null;
                                readonly edges: ReadonlyArray<{
                                    readonly cursor: string | null;
                                    readonly preview: {
                                        readonly link: string | null;
                                        readonly mediaAsset: {
                                            readonly files: ReadonlyArray<{
                                                readonly id: string;
                                                readonly name: string | null;
                                                readonly path: string | null;
                                            }> | null;
                                            readonly topLevelMediaType: {
                                                readonly kind: TopLevelMediaKind | null;
                                                readonly label: string | null;
                                            } | null;
                                        } | null;
                                        readonly kind: PreviewKind | null;
                                    } | null;
                                }> | null;
                            } | null;
                        } | null;
                    } | null;
                }> | null;
            } | null;
            readonly inspirations: ReadonlyArray<{
                readonly id: string;
                readonly inspirer: ({
                    readonly __typename: "Entity";
                    readonly id?: string;
                    readonly name?: string | null;
                    readonly landingPageUrl?: string | null;
                    readonly description?: string | null;
                    readonly websiteUrl?: string | null;
                    readonly hasPublicPage?: boolean | null;
                    readonly isEditable?: boolean | null;
                    readonly previews?: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly link: string | null;
                                readonly mediaAsset: {
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly path: string | null;
                                    }> | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                        readonly label: string | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                            } | null;
                        }> | null;
                    } | null;
                } & ({
                    readonly __typename: "Entity";
                    readonly id: string;
                    readonly name: string | null;
                    readonly landingPageUrl: string | null;
                    readonly description: string | null;
                    readonly websiteUrl: string | null;
                    readonly hasPublicPage: boolean | null;
                    readonly isEditable: boolean | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly link: string | null;
                                readonly mediaAsset: {
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly path: string | null;
                                    }> | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                        readonly label: string | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                            } | null;
                        }> | null;
                    } | null;
                } | {
                    /*This will never be '% other', but we need some
                    value in case none of the concrete values match.*/
                    readonly __typename: "%other";
                })) | null;
            }> | null;
            readonly investmentsBy: ReadonlyArray<{
                readonly id: string | null;
                readonly entity: {
                    readonly __typename: string;
                    readonly id: string;
                    readonly name: string | null;
                    readonly description: string | null;
                    readonly websiteUrl: string | null;
                    readonly landingPageUrl: string | null;
                    readonly hasPublicPage: boolean | null;
                    readonly isEditable: boolean | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly link: string | null;
                                readonly mediaAsset: {
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly path: string | null;
                                    }> | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                        readonly label: string | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                            } | null;
                        }> | null;
                    } | null;
                } | null;
                readonly investee: {
                    readonly __typename: string;
                    readonly name: string | null;
                    readonly id: string;
                    readonly landingPageUrl: string | null;
                    readonly description: string | null;
                    readonly websiteUrl: string | null;
                    readonly hasPublicPage: boolean | null;
                    readonly isEditable: boolean | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly link: string | null;
                                readonly mediaAsset: {
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly path: string | null;
                                    }> | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                        readonly label: string | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                            } | null;
                        }> | null;
                    } | null;
                } | null;
            }> | null;
            readonly follows: ReadonlyArray<{
                readonly __typename: "Entity";
                readonly name?: string | null;
                readonly id?: string;
                readonly landingPageUrl?: string | null;
                readonly previews?: {
                    readonly count: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly preview: {
                            readonly link: string | null;
                            readonly kind: PreviewKind | null;
                            readonly mediaAsset: {
                                readonly files: ReadonlyArray<{
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly path: string | null;
                                }> | null;
                                readonly topLevelMediaType: {
                                    readonly kind: TopLevelMediaKind | null;
                                    readonly label: string | null;
                                } | null;
                                readonly id?: string;
                            } | null;
                        } | null;
                    }> | null;
                } | null;
                readonly description?: string | null;
                readonly fullName?: string | null;
                readonly hasPublicPage?: boolean | null;
                readonly greeting?: string | null;
            } & ({
                readonly __typename: "Entity";
                readonly name: string | null;
                readonly id: string;
                readonly landingPageUrl: string | null;
                readonly previews: {
                    readonly count: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly preview: {
                            readonly link: string | null;
                            readonly kind: PreviewKind | null;
                            readonly mediaAsset: {
                                readonly files: ReadonlyArray<{
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly path: string | null;
                                }> | null;
                                readonly topLevelMediaType: {
                                    readonly kind: TopLevelMediaKind | null;
                                    readonly label: string | null;
                                } | null;
                                readonly id?: string;
                            } | null;
                        } | null;
                    }> | null;
                } | null;
            } | {
                readonly description: string | null;
                readonly fullName: string | null;
                readonly hasPublicPage: boolean | null;
                readonly greeting: string | null;
            } | {
                /*This will never be '% other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            })> | null;
            readonly mediaAbout: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly story: ({
                        readonly __typename: string;
                        readonly id?: string;
                        readonly link?: string | null;
                        readonly previews?: {
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly link: string | null;
                                    readonly kind: PreviewKind | null;
                                    readonly mediaAsset: {
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly path: string | null;
                                        }> | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                            readonly label: string | null;
                                        } | null;
                                        readonly id: string;
                                    } | null;
                                } | null;
                            }> | null;
                            readonly count: number | null;
                        } | null;
                        readonly subTitle?: string | null;
                        readonly title?: string | null;
                        readonly description?: string | null;
                        readonly landingPageUrl?: string | null;
                        readonly revision?: string | null;
                        readonly content?: string | null;
                        readonly cost?: string | null;
                        readonly publisher?: string | null;
                        readonly publishedDate?: unknown | null;
                        readonly timeRequiredInSeconds?: number | null;
                        readonly timeToReadInSeconds?: number | null;
                        readonly durationInSeconds?: number | null;
                    } & ({
                        readonly __typename: "RadivisionPost";
                        readonly id: string;
                        readonly link: string | null;
                        readonly previews: {
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly link: string | null;
                                    readonly kind: PreviewKind | null;
                                    readonly mediaAsset: {
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly path: string | null;
                                        }> | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                            readonly label: string | null;
                                        } | null;
                                        readonly id: string;
                                    } | null;
                                } | null;
                            }> | null;
                            readonly count: number | null;
                        } | null;
                        readonly subTitle: string | null;
                        readonly title: string | null;
                        readonly description: string | null;
                        readonly landingPageUrl: string | null;
                        readonly revision: string | null;
                        readonly content: string | null;
                    } | {
                        readonly __typename: "OnlineCourseStory";
                        readonly cost: string | null;
                        readonly publisher: string | null;
                        readonly publishedDate: unknown | null;
                        readonly timeRequiredInSeconds: number | null;
                    } | {
                        readonly __typename: "ArticleStory";
                        readonly timeToReadInSeconds: number | null;
                    } | {
                        readonly __typename: "PodcastStory";
                        readonly durationInSeconds: number | null;
                    } | {
                        /*This will never be '% other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    })) | null;
                }> | null;
            } | null;
            readonly responsibility: string | null;
            readonly superPower: string | null;
            readonly websiteUrl: string | null;
            readonly northStar: {
                readonly __typename: string;
                readonly description: string | null;
                readonly id: string;
                readonly questions: ReadonlyArray<{
                    readonly __typename: string;
                    readonly content?: string | null;
                    readonly id?: string;
                    readonly response?: {
                        readonly content: string | null;
                        readonly id: string;
                    } | null;
                } & ({
                    readonly __typename: "TextQuestion";
                    readonly content: string | null;
                    readonly id: string;
                    readonly response: {
                        readonly content: string | null;
                        readonly id: string;
                    } | null;
                } | {
                    /*This will never be '% other', but we need some
                    value in case none of the concrete values match.*/
                    readonly __typename: "%other";
                })> | null;
            } | null;
            readonly socialMediaCredentials: ReadonlyArray<{
                readonly credential: string | null;
                readonly platform: {
                    readonly kind: SocialMediaPlatformKind | null;
                };
            }> | null;
            readonly questionnaires: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly node: {
                        readonly questions: ReadonlyArray<{
                            readonly __typename: string;
                            readonly id?: string;
                            readonly title?: string | null;
                            readonly choices?: ReadonlyArray<{
                                readonly acceptsText: boolean | null;
                                readonly id: string;
                            }> | null;
                            readonly response?: {
                                readonly choices: ReadonlyArray<{
                                    readonly id: string;
                                    readonly title: string | null;
                                }> | null;
                                readonly content?: string | null;
                                readonly id?: string;
                            } | null;
                            readonly content?: string | null;
                        } & ({
                            readonly __typename: "MultipleChoiceQuestion";
                            readonly id: string;
                            readonly title: string | null;
                            readonly choices: ReadonlyArray<{
                                readonly acceptsText: boolean | null;
                                readonly id: string;
                            }> | null;
                            readonly response: {
                                readonly choices: ReadonlyArray<{
                                    readonly id: string;
                                    readonly title: string | null;
                                }> | null;
                                readonly content?: string | null;
                                readonly id?: string;
                            } | null;
                        } | {
                            readonly __typename: "TextQuestion";
                            readonly content: string | null;
                        } | {
                            /*This will never be '% other', but we need some
                            value in case none of the concrete values match.*/
                            readonly __typename: "%other";
                        })> | null;
                    } | null;
                }> | null;
            } | null;
            readonly socialMediaProfiles: ReadonlyArray<{
                readonly id: string;
                readonly link: string | null;
                readonly platform: {
                    readonly id: string;
                    readonly kind: SocialMediaPlatformKind | null;
                } | null;
            }> | null;
        } | null;
    } | null;
};
export type personQuery = {
    readonly response: personQueryResponse;
    readonly variables: personQueryVariables;
};



/*
query personQuery(
  $id: ID!
) {
  person(id: $id) {
    hasErrors
    person {
      __typename
      description
      emailAddresses
      fullName
      accountType {
        kind
        subKind
        description
      }
      hasPublicPage
      isEditable
      isClaimable
      landingPageUrl
      revision
      id
      greeting
      myList
      defaultLocation {
        id
        label
      }
      locations {
        id
        label
      }
      previews {
        count
        edges {
          cursor
          preview {
            link
            kind
            mediaAsset {
              id
              files {
                id
                name
                path
              }
              topLevelMediaType {
                kind
                label
                id
              }
            }
          }
        }
      }
      entities {
        __typename
        name
        id
        revision
        hasPublicPage
        description
        tagLine
        websiteUrl
        landingPageUrl
        isEditable
        previews {
          count
          edges {
            cursor
            preview {
              link
              mediaAsset {
                id
                files {
                  id
                  name
                  path
                }
                topLevelMediaType {
                  kind
                  label
                  id
                }
              }
              kind
            }
          }
        }
      }
      experience {
        count
        edges {
          cursor
          position {
            id
            isCurrent
            isDeleted
            isFounder
            title
            entity {
              __typename
              name
              id
              description
              websiteUrl
              hasPublicPage
              isEditable
              landingPageUrl
              previews {
                count
                edges {
                  cursor
                  preview {
                    link
                    mediaAsset {
                      files {
                        id
                        name
                        path
                      }
                      topLevelMediaType {
                        kind
                        label
                        id
                      }
                      id
                    }
                    kind
                  }
                }
              }
            }
          }
        }
      }
      inspirations {
        id
        inspirer {
          __typename
          ... on Entity {
            __typename
            id
            name
            landingPageUrl
            description
            websiteUrl
            hasPublicPage
            isEditable
            previews {
              count
              edges {
                cursor
                preview {
                  link
                  mediaAsset {
                    files {
                      id
                      name
                      path
                    }
                    topLevelMediaType {
                      kind
                      label
                      id
                    }
                    id
                  }
                  kind
                }
              }
            }
          }
          ... on Node {
            id
          }
        }
      }
      investmentsBy {
        id
        entity {
          __typename
          id
          name
          description
          websiteUrl
          landingPageUrl
          hasPublicPage
          isEditable
          previews {
            count
            edges {
              cursor
              preview {
                link
                mediaAsset {
                  files {
                    id
                    name
                    path
                  }
                  topLevelMediaType {
                    kind
                    label
                    id
                  }
                  id
                }
                kind
              }
            }
          }
        }
        investee {
          __typename
          name
          id
          landingPageUrl
          description
          websiteUrl
          hasPublicPage
          isEditable
          previews {
            count
            edges {
              cursor
              preview {
                link
                mediaAsset {
                  files {
                    id
                    name
                    path
                  }
                  topLevelMediaType {
                    kind
                    label
                    id
                  }
                  id
                }
                kind
              }
            }
          }
        }
      }
      follows {
        __typename
        ... on Entity {
          __typename
          name
          id
          landingPageUrl
          previews {
            count
            edges {
              cursor
              preview {
                link
                kind
                mediaAsset {
                  files {
                    id
                    name
                    path
                  }
                  topLevelMediaType {
                    kind
                    label
                    id
                  }
                  id
                }
              }
            }
          }
        }
        ... on Person {
          __typename
          description
          fullName
          hasPublicPage
          id
          greeting
          landingPageUrl
          previews {
            count
            edges {
              cursor
              preview {
                link
                kind
                mediaAsset {
                  id
                  files {
                    id
                    name
                    path
                  }
                  topLevelMediaType {
                    kind
                    label
                    id
                  }
                }
              }
            }
          }
        }
        ... on Node {
          id
        }
      }
      mediaAbout {
        count
        edges {
          cursor
          story {
            __typename
            ... on RadivisionPost {
              id
              link
              previews {
                edges {
                  cursor
                  preview {
                    link
                    kind
                    mediaAsset {
                      files {
                        id
                        name
                        path
                      }
                      topLevelMediaType {
                        kind
                        label
                        id
                      }
                      id
                    }
                  }
                }
                count
              }
              subTitle
              title
              description
              landingPageUrl
              revision
              content
            }
            ... on OnlineCourseStory {
              id
              link
              cost
              publisher
              publishedDate
              timeRequiredInSeconds
              description
              previews {
                count
                edges {
                  cursor
                  preview {
                    link
                    mediaAsset {
                      id
                      files {
                        id
                        name
                        path
                      }
                      topLevelMediaType {
                        kind
                        label
                        id
                      }
                    }
                    kind
                  }
                }
              }
              subTitle
              title
              revision
            }
            ... on ArticleStory {
              description
              id
              link
              publisher
              publishedDate
              timeToReadInSeconds
              previews {
                count
                edges {
                  cursor
                  preview {
                    link
                    mediaAsset {
                      id
                      files {
                        id
                        name
                        path
                      }
                      topLevelMediaType {
                        kind
                        label
                        id
                      }
                    }
                    kind
                  }
                }
              }
              revision
              subTitle
              title
            }
            ... on BookStory {
              id
              link
              cost
              description
              publisher
              publishedDate
              timeToReadInSeconds
              previews {
                count
                edges {
                  cursor
                  preview {
                    link
                    mediaAsset {
                      files {
                        id
                        name
                        path
                      }
                      topLevelMediaType {
                        kind
                        label
                        id
                      }
                      id
                    }
                    kind
                  }
                }
              }
              subTitle
              title
              revision
            }
            ... on NewsletterStory {
              id
              description
              link
              cost
              publisher
              publishedDate
              timeToReadInSeconds
              previews {
                count
                edges {
                  cursor
                  preview {
                    link
                    mediaAsset {
                      files {
                        id
                        name
                        path
                      }
                      topLevelMediaType {
                        kind
                        label
                        id
                      }
                      id
                    }
                    kind
                  }
                }
              }
              subTitle
              title
              revision
            }
            ... on PodcastStory {
              id
              link
              cost
              description
              durationInSeconds
              publisher
              publishedDate
              previews {
                count
                edges {
                  cursor
                  preview {
                    link
                    mediaAsset {
                      files {
                        id
                        name
                        path
                      }
                      topLevelMediaType {
                        kind
                        label
                        id
                      }
                      id
                    }
                    kind
                  }
                }
              }
              subTitle
              title
              revision
            }
            ... on OriginalContentStory {
              id
              previews {
                count
                edges {
                  cursor
                  preview {
                    link
                    mediaAsset {
                      files {
                        id
                        name
                        path
                      }
                      topLevelMediaType {
                        kind
                        label
                        id
                      }
                      id
                    }
                    kind
                  }
                }
              }
              subTitle
              title
              revision
            }
            ... on Node {
              id
            }
          }
        }
      }
      responsibility
      superPower
      websiteUrl
      northStar {
        __typename
        description
        id
        questions {
          __typename
          ... on TextQuestion {
            content
            id
            response {
              content
              id
            }
          }
          ... on MultipleChoiceQuestion {
            id
          }
        }
      }
      socialMediaCredentials {
        credential
        platform {
          kind
          id
        }
        id
      }
      questionnaires {
        count
        edges {
          cursor
          node {
            questions {
              __typename
              ... on MultipleChoiceQuestion {
                id
                title
                choices {
                  acceptsText
                  id
                }
                response {
                  choices {
                    id
                    title
                  }
                  id
                }
              }
              ... on TextQuestion {
                id
                content
                response {
                  content
                  id
                }
                title
              }
            }
            id
          }
        }
      }
      socialMediaProfiles {
        id
        link
        platform {
          id
          kind
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasErrors",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "emailAddresses",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "kind",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "accountType",
  "storageKey": null,
  "args": null,
  "concreteType": "accountType",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "subKind",
      "args": null,
      "storageKey": null
    },
    (v4/*: any*/)
  ]
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasPublicPage",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isEditable",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isClaimable",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "landingPageUrl",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revision",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "greeting",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "myList",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v18 = [
  (v14/*: any*/),
  (v17/*: any*/)
],
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "defaultLocation",
  "storageKey": null,
  "args": null,
  "concreteType": "GeographicalLocation",
  "plural": false,
  "selections": (v18/*: any*/)
},
v20 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "locations",
  "storageKey": null,
  "args": null,
  "concreteType": "GeographicalLocation",
  "plural": true,
  "selections": (v18/*: any*/)
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "files",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAssetFile",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    (v24/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }
  ]
},
v26 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "topLevelMediaType",
  "storageKey": null,
  "args": null,
  "concreteType": "TopLevelMediaType",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v17/*: any*/)
  ]
},
v27 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "mediaAsset",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAsset",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v25/*: any*/),
    (v26/*: any*/)
  ]
},
v28 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v22/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            (v23/*: any*/),
            (v7/*: any*/),
            (v27/*: any*/)
          ]
        }
      ]
    }
  ]
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "tagLine",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "websiteUrl",
  "args": null,
  "storageKey": null
},
v31 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v22/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            (v23/*: any*/),
            (v27/*: any*/),
            (v7/*: any*/)
          ]
        }
      ]
    }
  ]
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isCurrent",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isDeleted",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isFounder",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v36 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "mediaAsset",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAsset",
  "plural": false,
  "selections": [
    (v25/*: any*/),
    (v26/*: any*/)
  ]
},
v37 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v22/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            (v23/*: any*/),
            (v36/*: any*/),
            (v7/*: any*/)
          ]
        }
      ]
    }
  ]
},
v38 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "edges",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewEdge",
  "plural": true,
  "selections": [
    (v22/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "preview",
      "storageKey": null,
      "args": null,
      "concreteType": "Preview",
      "plural": false,
      "selections": [
        (v23/*: any*/),
        (v7/*: any*/),
        (v36/*: any*/)
      ]
    }
  ]
},
v39 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subTitle",
  "args": null,
  "storageKey": null
},
v40 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "content",
  "args": null,
  "storageKey": null
},
v41 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cost",
  "args": null,
  "storageKey": null
},
v42 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publisher",
  "args": null,
  "storageKey": null
},
v43 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publishedDate",
  "args": null,
  "storageKey": null
},
v44 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "timeRequiredInSeconds",
  "args": null,
  "storageKey": null
},
v45 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "timeToReadInSeconds",
  "args": null,
  "storageKey": null
},
v46 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "durationInSeconds",
  "args": null,
  "storageKey": null
},
v47 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "responsibility",
  "args": null,
  "storageKey": null
},
v48 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "superPower",
  "args": null,
  "storageKey": null
},
v49 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "response",
  "storageKey": null,
  "args": null,
  "concreteType": "TextQuestionResponse",
  "plural": false,
  "selections": [
    (v40/*: any*/),
    (v14/*: any*/)
  ]
},
v50 = {
  "kind": "InlineFragment",
  "type": "TextQuestion",
  "selections": [
    (v40/*: any*/),
    (v14/*: any*/),
    (v49/*: any*/)
  ]
},
v51 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "credential",
  "args": null,
  "storageKey": null
},
v52 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "choices",
  "storageKey": null,
  "args": null,
  "concreteType": "MultipleChoiceQuestionChoice",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "acceptsText",
      "args": null,
      "storageKey": null
    },
    (v14/*: any*/)
  ]
},
v53 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "choices",
  "storageKey": null,
  "args": null,
  "concreteType": "MultipleChoiceQuestionChoice",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    (v35/*: any*/)
  ]
},
v54 = {
  "kind": "InlineFragment",
  "type": "TextQuestion",
  "selections": [
    (v14/*: any*/),
    (v40/*: any*/),
    (v49/*: any*/),
    (v35/*: any*/)
  ]
},
v55 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "socialMediaProfiles",
  "storageKey": null,
  "args": null,
  "concreteType": "SocialMediaProfile",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    (v23/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "platform",
      "storageKey": null,
      "args": null,
      "concreteType": "SocialMediaPlatform",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        (v7/*: any*/)
      ]
    }
  ]
},
v56 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "topLevelMediaType",
  "storageKey": null,
  "args": null,
  "concreteType": "TopLevelMediaType",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v17/*: any*/),
    (v14/*: any*/)
  ]
},
v57 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "mediaAsset",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAsset",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v25/*: any*/),
    (v56/*: any*/)
  ]
},
v58 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v22/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            (v23/*: any*/),
            (v7/*: any*/),
            (v57/*: any*/)
          ]
        }
      ]
    }
  ]
},
v59 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v22/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            (v23/*: any*/),
            (v57/*: any*/),
            (v7/*: any*/)
          ]
        }
      ]
    }
  ]
},
v60 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "mediaAsset",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAsset",
  "plural": false,
  "selections": [
    (v25/*: any*/),
    (v56/*: any*/),
    (v14/*: any*/)
  ]
},
v61 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v22/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            (v23/*: any*/),
            (v60/*: any*/),
            (v7/*: any*/)
          ]
        }
      ]
    }
  ]
},
v62 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "edges",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewEdge",
  "plural": true,
  "selections": [
    (v22/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "preview",
      "storageKey": null,
      "args": null,
      "concreteType": "Preview",
      "plural": false,
      "selections": [
        (v23/*: any*/),
        (v7/*: any*/),
        (v60/*: any*/)
      ]
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "personQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "person",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "PersonPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "person",
            "storageKey": null,
            "args": null,
            "concreteType": "Person",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v28/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "entities",
                "storageKey": null,
                "args": null,
                "concreteType": "Entity",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v24/*: any*/),
                  (v14/*: any*/),
                  (v13/*: any*/),
                  (v9/*: any*/),
                  (v4/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v12/*: any*/),
                  (v10/*: any*/),
                  (v31/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "experience",
                "storageKey": null,
                "args": null,
                "concreteType": "PositionsConnection",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PositionEdge",
                    "plural": true,
                    "selections": [
                      (v22/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "position",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Position",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "entity",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Entity",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v24/*: any*/),
                              (v14/*: any*/),
                              (v4/*: any*/),
                              (v30/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v12/*: any*/),
                              (v37/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "inspirations",
                "storageKey": null,
                "args": null,
                "concreteType": "Inspiration",
                "plural": true,
                "selections": [
                  (v14/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "inspirer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "type": "Entity",
                        "selections": [
                          (v3/*: any*/),
                          (v14/*: any*/),
                          (v24/*: any*/),
                          (v12/*: any*/),
                          (v4/*: any*/),
                          (v30/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v37/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "investmentsBy",
                "storageKey": null,
                "args": null,
                "concreteType": "Investment",
                "plural": true,
                "selections": [
                  (v14/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "entity",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Entity",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v14/*: any*/),
                      (v24/*: any*/),
                      (v4/*: any*/),
                      (v30/*: any*/),
                      (v12/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v37/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "investee",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Entity",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v24/*: any*/),
                      (v14/*: any*/),
                      (v12/*: any*/),
                      (v4/*: any*/),
                      (v30/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v37/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "follows",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "type": "Entity",
                    "selections": [
                      (v3/*: any*/),
                      (v24/*: any*/),
                      (v14/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "previews",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PreviewsConnection",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v38/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "Person",
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v6/*: any*/),
                      (v9/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v12/*: any*/),
                      (v28/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "mediaAbout",
                "storageKey": null,
                "args": null,
                "concreteType": "StoriesConnection",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StoryEdge",
                    "plural": true,
                    "selections": [
                      (v22/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "story",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "type": "RadivisionPost",
                            "selections": [
                              (v14/*: any*/),
                              (v23/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "previews",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PreviewsConnection",
                                "plural": false,
                                "selections": [
                                  (v38/*: any*/),
                                  (v21/*: any*/)
                                ]
                              },
                              (v39/*: any*/),
                              (v35/*: any*/),
                              (v4/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v40/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "OnlineCourseStory",
                            "selections": [
                              (v14/*: any*/),
                              (v23/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/),
                              (v43/*: any*/),
                              (v44/*: any*/),
                              (v4/*: any*/),
                              (v31/*: any*/),
                              (v39/*: any*/),
                              (v35/*: any*/),
                              (v13/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "ArticleStory",
                            "selections": [
                              (v4/*: any*/),
                              (v14/*: any*/),
                              (v23/*: any*/),
                              (v42/*: any*/),
                              (v43/*: any*/),
                              (v45/*: any*/),
                              (v31/*: any*/),
                              (v13/*: any*/),
                              (v39/*: any*/),
                              (v35/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "BookStory",
                            "selections": [
                              (v14/*: any*/),
                              (v23/*: any*/),
                              (v41/*: any*/),
                              (v4/*: any*/),
                              (v42/*: any*/),
                              (v43/*: any*/),
                              (v45/*: any*/),
                              (v37/*: any*/),
                              (v39/*: any*/),
                              (v35/*: any*/),
                              (v13/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "NewsletterStory",
                            "selections": [
                              (v14/*: any*/),
                              (v4/*: any*/),
                              (v23/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/),
                              (v43/*: any*/),
                              (v45/*: any*/),
                              (v37/*: any*/),
                              (v39/*: any*/),
                              (v35/*: any*/),
                              (v13/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "PodcastStory",
                            "selections": [
                              (v14/*: any*/),
                              (v23/*: any*/),
                              (v41/*: any*/),
                              (v4/*: any*/),
                              (v46/*: any*/),
                              (v42/*: any*/),
                              (v43/*: any*/),
                              (v37/*: any*/),
                              (v39/*: any*/),
                              (v35/*: any*/),
                              (v13/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "OriginalContentStory",
                            "selections": [
                              (v14/*: any*/),
                              (v37/*: any*/),
                              (v39/*: any*/),
                              (v35/*: any*/),
                              (v13/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v47/*: any*/),
              (v48/*: any*/),
              (v30/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "northStar",
                "storageKey": null,
                "args": null,
                "concreteType": "Questionnaire",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v14/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "questions",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v50/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "socialMediaCredentials",
                "storageKey": null,
                "args": null,
                "concreteType": "SocialMediaCredential",
                "plural": true,
                "selections": [
                  (v51/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "platform",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SocialMediaPlatform",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "questionnaires",
                "storageKey": null,
                "args": null,
                "concreteType": "QuestionnairesConnection",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "QuestionnaireEdge",
                    "plural": true,
                    "selections": [
                      (v22/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Questionnaire",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "questions",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "type": "MultipleChoiceQuestion",
                                "selections": [
                                  (v14/*: any*/),
                                  (v35/*: any*/),
                                  (v52/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "response",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MultipleChoiceQuestionResponse",
                                    "plural": false,
                                    "selections": [
                                      (v53/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v54/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v55/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "personQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "person",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "PersonPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "person",
            "storageKey": null,
            "args": null,
            "concreteType": "Person",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v58/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "entities",
                "storageKey": null,
                "args": null,
                "concreteType": "Entity",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v24/*: any*/),
                  (v14/*: any*/),
                  (v13/*: any*/),
                  (v9/*: any*/),
                  (v4/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v12/*: any*/),
                  (v10/*: any*/),
                  (v59/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "experience",
                "storageKey": null,
                "args": null,
                "concreteType": "PositionsConnection",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PositionEdge",
                    "plural": true,
                    "selections": [
                      (v22/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "position",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Position",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "entity",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Entity",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v24/*: any*/),
                              (v14/*: any*/),
                              (v4/*: any*/),
                              (v30/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v12/*: any*/),
                              (v61/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "inspirations",
                "storageKey": null,
                "args": null,
                "concreteType": "Inspiration",
                "plural": true,
                "selections": [
                  (v14/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "inspirer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v14/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "Entity",
                        "selections": [
                          (v3/*: any*/),
                          (v24/*: any*/),
                          (v12/*: any*/),
                          (v4/*: any*/),
                          (v30/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v61/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "investmentsBy",
                "storageKey": null,
                "args": null,
                "concreteType": "Investment",
                "plural": true,
                "selections": [
                  (v14/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "entity",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Entity",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v14/*: any*/),
                      (v24/*: any*/),
                      (v4/*: any*/),
                      (v30/*: any*/),
                      (v12/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v61/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "investee",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Entity",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v24/*: any*/),
                      (v14/*: any*/),
                      (v12/*: any*/),
                      (v4/*: any*/),
                      (v30/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v61/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "follows",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v14/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "type": "Entity",
                    "selections": [
                      (v3/*: any*/),
                      (v24/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "previews",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PreviewsConnection",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v62/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "Person",
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v6/*: any*/),
                      (v9/*: any*/),
                      (v15/*: any*/),
                      (v12/*: any*/),
                      (v58/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "mediaAbout",
                "storageKey": null,
                "args": null,
                "concreteType": "StoriesConnection",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StoryEdge",
                    "plural": true,
                    "selections": [
                      (v22/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "story",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "type": "RadivisionPost",
                            "selections": [
                              (v23/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "previews",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PreviewsConnection",
                                "plural": false,
                                "selections": [
                                  (v62/*: any*/),
                                  (v21/*: any*/)
                                ]
                              },
                              (v39/*: any*/),
                              (v35/*: any*/),
                              (v4/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v40/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "OnlineCourseStory",
                            "selections": [
                              (v23/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/),
                              (v43/*: any*/),
                              (v44/*: any*/),
                              (v4/*: any*/),
                              (v59/*: any*/),
                              (v39/*: any*/),
                              (v35/*: any*/),
                              (v13/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "ArticleStory",
                            "selections": [
                              (v4/*: any*/),
                              (v23/*: any*/),
                              (v42/*: any*/),
                              (v43/*: any*/),
                              (v45/*: any*/),
                              (v59/*: any*/),
                              (v13/*: any*/),
                              (v39/*: any*/),
                              (v35/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "BookStory",
                            "selections": [
                              (v23/*: any*/),
                              (v41/*: any*/),
                              (v4/*: any*/),
                              (v42/*: any*/),
                              (v43/*: any*/),
                              (v45/*: any*/),
                              (v61/*: any*/),
                              (v39/*: any*/),
                              (v35/*: any*/),
                              (v13/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "NewsletterStory",
                            "selections": [
                              (v4/*: any*/),
                              (v23/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/),
                              (v43/*: any*/),
                              (v45/*: any*/),
                              (v61/*: any*/),
                              (v39/*: any*/),
                              (v35/*: any*/),
                              (v13/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "PodcastStory",
                            "selections": [
                              (v23/*: any*/),
                              (v41/*: any*/),
                              (v4/*: any*/),
                              (v46/*: any*/),
                              (v42/*: any*/),
                              (v43/*: any*/),
                              (v61/*: any*/),
                              (v39/*: any*/),
                              (v35/*: any*/),
                              (v13/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "OriginalContentStory",
                            "selections": [
                              (v61/*: any*/),
                              (v39/*: any*/),
                              (v35/*: any*/),
                              (v13/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v47/*: any*/),
              (v48/*: any*/),
              (v30/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "northStar",
                "storageKey": null,
                "args": null,
                "concreteType": "Questionnaire",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v14/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "questions",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v50/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "MultipleChoiceQuestion",
                        "selections": [
                          (v14/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "socialMediaCredentials",
                "storageKey": null,
                "args": null,
                "concreteType": "SocialMediaCredential",
                "plural": true,
                "selections": [
                  (v51/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "platform",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SocialMediaPlatform",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v14/*: any*/)
                    ]
                  },
                  (v14/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "questionnaires",
                "storageKey": null,
                "args": null,
                "concreteType": "QuestionnairesConnection",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "QuestionnaireEdge",
                    "plural": true,
                    "selections": [
                      (v22/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Questionnaire",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "questions",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "type": "MultipleChoiceQuestion",
                                "selections": [
                                  (v14/*: any*/),
                                  (v35/*: any*/),
                                  (v52/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "response",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MultipleChoiceQuestionResponse",
                                    "plural": false,
                                    "selections": [
                                      (v53/*: any*/),
                                      (v14/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v54/*: any*/)
                            ]
                          },
                          (v14/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v55/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "personQuery",
    "id": null,
    "text": "query personQuery(\n  $id: ID!\n) {\n  person(id: $id) {\n    hasErrors\n    person {\n      __typename\n      description\n      emailAddresses\n      fullName\n      accountType {\n        kind\n        subKind\n        description\n      }\n      hasPublicPage\n      isEditable\n      isClaimable\n      landingPageUrl\n      revision\n      id\n      greeting\n      myList\n      defaultLocation {\n        id\n        label\n      }\n      locations {\n        id\n        label\n      }\n      previews {\n        count\n        edges {\n          cursor\n          preview {\n            link\n            kind\n            mediaAsset {\n              id\n              files {\n                id\n                name\n                path\n              }\n              topLevelMediaType {\n                kind\n                label\n                id\n              }\n            }\n          }\n        }\n      }\n      entities {\n        __typename\n        name\n        id\n        revision\n        hasPublicPage\n        description\n        tagLine\n        websiteUrl\n        landingPageUrl\n        isEditable\n        previews {\n          count\n          edges {\n            cursor\n            preview {\n              link\n              mediaAsset {\n                id\n                files {\n                  id\n                  name\n                  path\n                }\n                topLevelMediaType {\n                  kind\n                  label\n                  id\n                }\n              }\n              kind\n            }\n          }\n        }\n      }\n      experience {\n        count\n        edges {\n          cursor\n          position {\n            id\n            isCurrent\n            isDeleted\n            isFounder\n            title\n            entity {\n              __typename\n              name\n              id\n              description\n              websiteUrl\n              hasPublicPage\n              isEditable\n              landingPageUrl\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    link\n                    mediaAsset {\n                      files {\n                        id\n                        name\n                        path\n                      }\n                      topLevelMediaType {\n                        kind\n                        label\n                        id\n                      }\n                      id\n                    }\n                    kind\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      inspirations {\n        id\n        inspirer {\n          __typename\n          ... on Entity {\n            __typename\n            id\n            name\n            landingPageUrl\n            description\n            websiteUrl\n            hasPublicPage\n            isEditable\n            previews {\n              count\n              edges {\n                cursor\n                preview {\n                  link\n                  mediaAsset {\n                    files {\n                      id\n                      name\n                      path\n                    }\n                    topLevelMediaType {\n                      kind\n                      label\n                      id\n                    }\n                    id\n                  }\n                  kind\n                }\n              }\n            }\n          }\n          ... on Node {\n            id\n          }\n        }\n      }\n      investmentsBy {\n        id\n        entity {\n          __typename\n          id\n          name\n          description\n          websiteUrl\n          landingPageUrl\n          hasPublicPage\n          isEditable\n          previews {\n            count\n            edges {\n              cursor\n              preview {\n                link\n                mediaAsset {\n                  files {\n                    id\n                    name\n                    path\n                  }\n                  topLevelMediaType {\n                    kind\n                    label\n                    id\n                  }\n                  id\n                }\n                kind\n              }\n            }\n          }\n        }\n        investee {\n          __typename\n          name\n          id\n          landingPageUrl\n          description\n          websiteUrl\n          hasPublicPage\n          isEditable\n          previews {\n            count\n            edges {\n              cursor\n              preview {\n                link\n                mediaAsset {\n                  files {\n                    id\n                    name\n                    path\n                  }\n                  topLevelMediaType {\n                    kind\n                    label\n                    id\n                  }\n                  id\n                }\n                kind\n              }\n            }\n          }\n        }\n      }\n      follows {\n        __typename\n        ... on Entity {\n          __typename\n          name\n          id\n          landingPageUrl\n          previews {\n            count\n            edges {\n              cursor\n              preview {\n                link\n                kind\n                mediaAsset {\n                  files {\n                    id\n                    name\n                    path\n                  }\n                  topLevelMediaType {\n                    kind\n                    label\n                    id\n                  }\n                  id\n                }\n              }\n            }\n          }\n        }\n        ... on Person {\n          __typename\n          description\n          fullName\n          hasPublicPage\n          id\n          greeting\n          landingPageUrl\n          previews {\n            count\n            edges {\n              cursor\n              preview {\n                link\n                kind\n                mediaAsset {\n                  id\n                  files {\n                    id\n                    name\n                    path\n                  }\n                  topLevelMediaType {\n                    kind\n                    label\n                    id\n                  }\n                }\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n      mediaAbout {\n        count\n        edges {\n          cursor\n          story {\n            __typename\n            ... on RadivisionPost {\n              id\n              link\n              previews {\n                edges {\n                  cursor\n                  preview {\n                    link\n                    kind\n                    mediaAsset {\n                      files {\n                        id\n                        name\n                        path\n                      }\n                      topLevelMediaType {\n                        kind\n                        label\n                        id\n                      }\n                      id\n                    }\n                  }\n                }\n                count\n              }\n              subTitle\n              title\n              description\n              landingPageUrl\n              revision\n              content\n            }\n            ... on OnlineCourseStory {\n              id\n              link\n              cost\n              publisher\n              publishedDate\n              timeRequiredInSeconds\n              description\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    link\n                    mediaAsset {\n                      id\n                      files {\n                        id\n                        name\n                        path\n                      }\n                      topLevelMediaType {\n                        kind\n                        label\n                        id\n                      }\n                    }\n                    kind\n                  }\n                }\n              }\n              subTitle\n              title\n              revision\n            }\n            ... on ArticleStory {\n              description\n              id\n              link\n              publisher\n              publishedDate\n              timeToReadInSeconds\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    link\n                    mediaAsset {\n                      id\n                      files {\n                        id\n                        name\n                        path\n                      }\n                      topLevelMediaType {\n                        kind\n                        label\n                        id\n                      }\n                    }\n                    kind\n                  }\n                }\n              }\n              revision\n              subTitle\n              title\n            }\n            ... on BookStory {\n              id\n              link\n              cost\n              description\n              publisher\n              publishedDate\n              timeToReadInSeconds\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    link\n                    mediaAsset {\n                      files {\n                        id\n                        name\n                        path\n                      }\n                      topLevelMediaType {\n                        kind\n                        label\n                        id\n                      }\n                      id\n                    }\n                    kind\n                  }\n                }\n              }\n              subTitle\n              title\n              revision\n            }\n            ... on NewsletterStory {\n              id\n              description\n              link\n              cost\n              publisher\n              publishedDate\n              timeToReadInSeconds\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    link\n                    mediaAsset {\n                      files {\n                        id\n                        name\n                        path\n                      }\n                      topLevelMediaType {\n                        kind\n                        label\n                        id\n                      }\n                      id\n                    }\n                    kind\n                  }\n                }\n              }\n              subTitle\n              title\n              revision\n            }\n            ... on PodcastStory {\n              id\n              link\n              cost\n              description\n              durationInSeconds\n              publisher\n              publishedDate\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    link\n                    mediaAsset {\n                      files {\n                        id\n                        name\n                        path\n                      }\n                      topLevelMediaType {\n                        kind\n                        label\n                        id\n                      }\n                      id\n                    }\n                    kind\n                  }\n                }\n              }\n              subTitle\n              title\n              revision\n            }\n            ... on OriginalContentStory {\n              id\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    link\n                    mediaAsset {\n                      files {\n                        id\n                        name\n                        path\n                      }\n                      topLevelMediaType {\n                        kind\n                        label\n                        id\n                      }\n                      id\n                    }\n                    kind\n                  }\n                }\n              }\n              subTitle\n              title\n              revision\n            }\n            ... on Node {\n              id\n            }\n          }\n        }\n      }\n      responsibility\n      superPower\n      websiteUrl\n      northStar {\n        __typename\n        description\n        id\n        questions {\n          __typename\n          ... on TextQuestion {\n            content\n            id\n            response {\n              content\n              id\n            }\n          }\n          ... on MultipleChoiceQuestion {\n            id\n          }\n        }\n      }\n      socialMediaCredentials {\n        credential\n        platform {\n          kind\n          id\n        }\n        id\n      }\n      questionnaires {\n        count\n        edges {\n          cursor\n          node {\n            questions {\n              __typename\n              ... on MultipleChoiceQuestion {\n                id\n                title\n                choices {\n                  acceptsText\n                  id\n                }\n                response {\n                  choices {\n                    id\n                    title\n                  }\n                  id\n                }\n              }\n              ... on TextQuestion {\n                id\n                content\n                response {\n                  content\n                  id\n                }\n                title\n              }\n            }\n            id\n          }\n        }\n      }\n      socialMediaProfiles {\n        id\n        link\n        platform {\n          id\n          kind\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'fbb39047831942b92ad481cfc49a8905';
export default node;
